// NATIVE 
import React, { useEffect } from 'react';


// CUSTOM 
import { alpha, Avatar, Skeleton } from '@mui/material';
import { useDispatch } from 'react-redux';



// INSTALLED 
import { getImageStore } from '../store/files';




export const AvatarEmployeesInShift = ({ urlImage, typeImage }: any) => {


     // DISPATCH 
     const dispatch = useDispatch();


    // USE STATES
    const [logoUrl, setLogoUrl] = React.useState('');



    const getLogoImage = async(imageName:string) => { 
    

          const response =  await dispatch( getImageStore(imageName, typeImage) );


           if ( response instanceof Blob) {
              const imageUrl = URL.createObjectURL(response);
              setLogoUrl(imageUrl);
           }

    }


    useEffect(() => {
        getLogoImage(urlImage);
    }, [urlImage]);
    

  return (
    <>
       {
         logoUrl
            ?
           <Avatar
              sx={{
                  width: 56,
                  height: 56,
                  mb: 1,
                  border: `2px solid ${alpha('#fff', 0.8)}`,
                  boxShadow: 1
              }}
              alt="Logo Compañia"  
              src={ logoUrl }
              // variant='square'
          >
              Q
          </Avatar>
          : <Skeleton animation="wave" variant="rectangular"  width={56} height={56} />
       }
       
    </>
  )
}

